<script lang="ts">
  import { Col, Container, Image, Row } from "sveltestrap";
  import BookmarkHoverEffects from "./BookmarkHoverEffects.svelte";
  import Card from "../../../Core/Card.svelte";
  import data from "../../../../Data/Miscellaneous/Gallery.json"
  let imgPath:string = '/assets/images/lightgallry'

</script>
<BookmarkHoverEffects />
<Container fluid>
    {#each data.imagehoverdata as imageItem}
      <Row>
        <Col sm="12">
          <Card headerTitle={imageItem.title} cardHeaderprops="pb-0">
            <div slot="contentbody">
              <Row id="aniimated-thumbnials" class="my-gallery gallery">
                {#each imageItem.imgdata as imgItem}
                  <figure
                    itemProp="associatedMedia"
                    class="col-md-3 img-hover {imgItem.class}">
                    <div >
                        <Image
                          fluid
                          src="{imgPath}/{imgItem.img}"
                          class="media" />
                    </div>
                  </figure>
                {/each}
              </Row>
            </div>
          </Card>
        </Col>
      </Row>
    {/each}
</Container>